export default __webpack_public_path__ + "static/media/fe_dial_face.1d9d2461.svg";